import { useCallback } from 'react';
import { shutdownFiltersData } from '../../../shared/constants';
import { useSearchParams } from '../../../shared/lib/searchParams';

const {
  filters: { period, onlyActive },
} = shutdownFiltersData;

const ResetFilter = ({ render, ...props }) => {
  const [_searchParams, setSearchParams] = useSearchParams();

  const reset = useCallback(() => {
    setSearchParams({
      [period.name]: period.initialValue,
      [onlyActive.name]: onlyActive.initialValue,
    });
  }, []);

  return render({ reset, ...props });
};

export default ResetFilter;
